import {decimalsMultiplier} from '#/utils/contract-consts';
import {Land, LandMarketInfo, getLandPremium} from 'shareland-common';

const getLandColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) => landAndInfo.land.name;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => getValue(b).localeCompare(getValue(a));

  return {getValue, sort};
};

const getPriceColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.landMarketInfo?.marketPrice;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => (getValue(b) ?? 0) - (getValue(a) ?? 0);

  return {getValue, sort};
};

const getChangeColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.land.syntheticMarketData.marketPrice.daily.difference;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => getValue(b) - getValue(a);

  return {getValue, sort};
};

const getPremiumColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.landMarketInfo
      ? getLandPremium(landAndInfo.landMarketInfo.marketPrice, landAndInfo.landMarketInfo.oraclePrice)
      : undefined;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => (getValue(b) ?? 0) - (getValue(a) ?? 0);

  return {getValue, sort};
};

const getTVLColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.land.syntheticMarketData.tvl;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => getValue(b) - getValue(a);

  return {getValue, sort};
};

const getVolumeColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.land.syntheticMarketData.dailyVolume;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => getValue(b) - getValue(a);

  return {getValue, sort};
};

const getMarketCapColumn = () => {
  const getValue = (landAndInfo: {land: Land; landMarketInfo: LandMarketInfo | undefined}) =>
    landAndInfo.landMarketInfo?.totalSupply
      ? (landAndInfo.landMarketInfo.totalSupply * landAndInfo.landMarketInfo.marketPrice) / decimalsMultiplier
      : undefined;
  const sort = (
    a: {land: Land; landMarketInfo: LandMarketInfo | undefined},
    b: {land: Land; landMarketInfo: LandMarketInfo | undefined},
  ) => (getValue(b) ?? 0) - (getValue(a) ?? 0);

  return {getValue, sort};
};

export const landsTableSortableColumnData = {
  land: getLandColumn(),
  price: getPriceColumn(),
  change: getChangeColumn(),
  premium: getPremiumColumn(),
  tvl: getTVLColumn(),
  volume: getVolumeColumn(),
  marketCap: getMarketCapColumn(),
};
